angular.module('rjmNg.constants').constant('dashboardConstants',
  DIVIDER_TYPES: Object.freeze
    HEADING: 1
    BREAK: 2
)
